export const selector = 'dbAOnFocus';

/* @ngInject */
export default function OnFocusDirective() {
    return {
        restrict: 'A',

        link(scope, element, attrs) {
            element.on('focusin', focusHandler);
            scope.$on('$destroy', () => element.off('focusin', focusHandler));

            function focusHandler() {
                scope.$applyAsync(() => scope.$eval(attrs[selector]));
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/on-focus/on-focus.directive.js